// extracted by mini-css-extract-plugin
export default {"main":"ClientPanel_main__ld8Rf","data":"ClientPanel_data__I0P5-"};